import { AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { Area }           from 'src/app/core/models/api/area.model';
import { Classification } from 'src/app/core/models/api/classification.model';
import { ClassesCourse } from 'src/app/core/models/api/classes-course.model';
import { Edition }        from 'src/app/core/models/api/edition.model';

import { AreaResourceService } from 'src/app/core/services/api/area-resource.service';
import { CampusService }       from 'src/app/core/services/api/campus.service';
import { CourseService }       from 'src/app/core/services/api/course.service';
import { ClassService } from 'src/app/core/services/api/class.service';

@Component({
    selector: 'app-all-courses',
    templateUrl: './all-courses.component.html',
    styleUrls: ['./all-courses.component.scss']
})
export class AllCoursesComponent implements OnInit, AfterViewChecked, OnDestroy {
    
    private editionId    : number;
    public  edition      : Edition;

    public loadingData   : boolean = false;
    public  webResourceId: string = "courses-page";

    public courses        : ClassesCourse[];
    public areas          : Area[];
    // public languages      : Language[]
    public classifications: Classification[];

    public filteredCourses: ClassesCourse[];
    public filterValues   : any = { searchText: '', areas: {}, classifications: {} }
    
    private courseSubscription : Subscription;

    constructor(
        private changeDetectorRef: ChangeDetectorRef, 
        private activatedRoute: ActivatedRoute, 
        private campusService: CampusService,
        private classService: ClassService,
        private areaResourceService: AreaResourceService) { }
    
    ngOnInit() { 

        this.loadingData = false;
        this.getEditionFromRoute();
        this.subscribeToCourseService();

    }

    ngAfterViewChecked () {
        
        this.changeDetectorRef.detectChanges();

    }

    ngOnDestroy() {
        
        if (this.courseSubscription && !this.courseSubscription.closed) { this.courseSubscription.unsubscribe(); }
    
    }
    
    private getEditionFromRoute() {

        this.activatedRoute.paramMap.subscribe(params => {
            
            this.editionId = +params.get("editionId");
            this.edition   = this.campusService.campusActive.editions.find(e => e.editionId == this.editionId);
            this.classService.getClassesCoursesByEditionId(this.editionId).subscribe();

        });

    }

    private subscribeToCourseService() {

        this.courseSubscription = this.classService.classesCoursesData$.subscribe({
            next: (data) => { 

                this.courses         = data;
                this.courses         = this.loadCoursesGrouping();
                this.filteredCourses = this.courses;
                this.areas           = this.getDistinctAreas();
                // this.languages       = this.getDistinctLanguages();
                this.classifications = this.getDistinctClassifications();

                this.loadInitialFilters();
                this.loadingData = true;

            }
        });

    }

    private loadCoursesGrouping() : ClassesCourse[] {
        const coursesGrouping = this.courses.reduce((acc: ClassesCourse[], curr: ClassesCourse) => {
            if(acc.findIndex(course => (course.classificationId === curr.classificationId && curr.courseId === course.courseId)) === -1)
            {
                curr.classifications = [curr.classification];
                acc = [...acc, curr];
            }

            return acc;
        }, []);

        const coursesClassificationsGrouping = coursesGrouping.reduce((acc: ClassesCourse[], curr: ClassesCourse) => {
            const courses = acc.filter(course => course.courseId === curr.courseId);
            if(courses.length > 1)
            {
                curr.classifications = courses.map(course => course.classification)
                acc = [...acc.filter(h => h.courseId !== curr.courseId), curr]
            }

            return acc;
        }, coursesGrouping)
        return coursesClassificationsGrouping.sort((a: ClassesCourse, b: ClassesCourse) => (a.courseName > b.courseName ? 1 : -1));

    }

    private getDistinctAreas() : Area[] {

        var allAreas = [...new Set(this.courses.map(course => course.courseArea))];
        var areas    = allAreas.reduce((area, x) => area.concat(area.find((y: Area) => y.areaId === x.areaId) ? [] : [x]) , []).sort((a: Area, b: Area) => (a.name > b.name ? 1 : -1));
        
        return areas;
    }

    // private getDistinctLanguages() : Language[] {
       
    //     var allLanguages = [...new Set(this.courses.map(course => course.language))];
    //     var languages =  allLanguages.reduce((language, x) => language.concat(language.find((y: Language) => y.languageId === x.languageId) ? [] : [x]) , []).sort((a: Language, b: Language) => (a.name > b.name ? 1 : -1));

    //     return languages;

    // }

    private getDistinctClassifications() : Classification[] {

        var arrayClassifications = [...new Set(this.courses.map(course => course.classifications))]
        var allClassifications   = [].concat(...arrayClassifications);
        var classifications = allClassifications.reduce((classification, x) => classification.concat(classification.find((y: Classification) => y.classificationId === x.classificationId) ? [] : [x]) , []).sort((a: Classification, b: Classification) => (a.name > b.name ? 1 : -1));
        
        return classifications;

    }

    private loadInitialFilters() {

        this.areas.forEach(area => {
            this.filterValues.areas[area.areaId] = true;
        })

        // this.languages.forEach(language => {
        //     this.filterValues.languages[language.languageId] = true;
        // });

        this.classifications.forEach(classification => {
            this.filterValues.classifications[classification.classificationId] = true;
        });

    }

    // #region Filters

    filterCourses() {

        this.filteredCourses = this.courses;

        // Filters by search text.
        this.filterBySearchText();

        // Filters by area selection.
        this.filterByAreaSelection();

        // Filters by language selection.
        // this.filterByLanguageSelection();

        // Filters by classification selection.
        this.filterByClassificationSelection();

    }

    filterBySearchText() {

        if (this.filterValues.searchText != '') {
            
            this.filteredCourses = this.courses.filter(course => 
                this.removeAccents(course.courseName.toLowerCase()).includes(this.removeAccents(this.filterValues.searchText.toLowerCase())) ||
                this.removeAccents(course.courseArea.name.toLowerCase()).includes(this.removeAccents(this.filterValues.searchText.toLowerCase()))
            );
            
        } 

    }
    
    filterByAreaSelection() {

        var areasKeys   = Object.keys(this.filterValues.areas);
        var areasValues = Object.values(this.filterValues.areas);

        if (areasValues.includes(true)) {
            
            areasKeys.forEach((areaKey: string) => {
                if (!this.filterValues.areas[+areaKey]) {
                    this.filteredCourses = this.filteredCourses.filter(course => course.courseArea.areaId !== +areaKey);
                }
            });

        } else {

            this.filteredCourses = [];

        }

    }

    // filterByLanguageSelection() {

    //     var languagesKeys   = Object.keys(this.filterValues.languages);
    //     var languagesValues = Object.values(this.filterValues.languages);

    //     if (languagesValues.includes(true)) {
            
    //         languagesKeys.forEach((languageKey: string) => {
    //             if (!this.filterValues.languages[+languageKey]) {
    //                 this.filteredCourses = this.filteredCourses.filter(course => course.language.languageId !== +languageKey);
    //             }
    //         });

    //     } else {

    //         this.filteredCourses = [];

    //     }

    // }

    filterByClassificationSelection() {

        var classificationsKeys  = Object.keys(this.filterValues.classifications);
        var classificationValues = Object.values(this.filterValues.classifications);

        if (classificationValues.includes(true)) {
            classificationsKeys.forEach((classificationKey: string) => {
                if (!this.filterValues.classifications[+classificationKey]) {
                    this.filteredCourses = this.filteredCourses.filter(course => 
                        course.classifications.filter(classification => classification.classificationId !== +classificationKey).length > 0);
                }
            });

        } else {

            this.filteredCourses = [];

        }
    
    }
    
    private removeAccents(text: string) : string {

        // Removes all accents and symbols except letter Ñ.
        return text
            .normalize('NFD')
            .replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1")
            .normalize();
    }

    //#endregion

    getAreaIconPath(area: Area) : string {

        return this.areaResourceService.findResource(area.resources, 'icon');

    }

}
